/* ============================================================
   product.js — de productpagina: varianten, gallery, aantal.

   Drie dingen:
   1. variantkeuze — prijs, beschikbaarheid, knoptekst en de URL bijwerken;
   2. de gallery meelaten filteren met de gekozen tint (dat is bij Iconic het
      hele idee van de PDP, en bij MARR juist de plek waar het potlood met twee
      tinten van profiteert);
   3. het aantalveld met plus en min.

   Zonder JavaScript blijft de pagina werken: de radio's staan in het formulier,
   de knop post naar /cart/add en alle beelden staan gewoon in de gallery.
   ============================================================ */
(() => {
  document.querySelectorAll('variant-options.js-variant-options').forEach((blok) => {
    const wortel = blok.closest('.product');
    if (!wortel) return;
    const bron = blok.querySelector('[data-varianten]');
    let varianten = [];
    try { varianten = JSON.parse(bron?.textContent || '[]'); } catch (e) { varianten = []; }

    // Op het PAD zoeken, niet op de tekst van het attribuut: Shopify zet er bij
    // elke voorbeeldweergave een queryreeks achter. Zie cart.js voor de meting.
    const form = [...wortel.querySelectorAll('form[action]')].find((f) => {
      try { return /(^|\/)cart\/add\/?$/.test(new URL(f.getAttribute('action'), location.href).pathname); }
      catch (e) { return false; }
    });
    const idVeld = form?.querySelector('.product-variant-id');
    const knop = form?.querySelector('[name="add"]');
    const prijsVelden = wortel.querySelectorAll('.prijs');
    const knopPrijs = wortel.querySelector('.js-add-to-cart-price');
    /* De ene live region van de PDP (D2 punt 12). Zie sections/main-product.liquid;
       `snippets/prijs.liquid` heeft zijn `role="status"` afgestaan aan deze. */
    const prijsMelding = wortel.querySelector('.js-prijs-melding');

    const gekozen = () => [...blok.querySelectorAll('input[type="radio"]:checked')].map((i) => i.value);

    const zoekVariant = () => {
      const keuze = gekozen();
      return varianten.find((v) => keuze.every((w, i) => (v.options || [])[i] === w));
    };

    /* De gallery volgt de gekozen tint. Niet door de andere beelden te VERBERGEN:
       vanaf tablet is dit een raster van twee kolommen, en daar een paar tegels
       uit weghalen laat een gatenkaas achter — het origineel houdt ze ook alle
       negen staan. We springen naar het eerste beeld van die tint; op mobiel is
       dat de slide, op desktop scrolt hij in beeld. */
    const volgTint = () => {
      const tint = (gekozen()[0] || '').toLowerCase().replace(/[^a-z0-9]+/g, '-');
      if (!tint) return;
      const doel = wortel.querySelector(`.slider--media-gallery .slider__item[data-tint="${tint}"]`);
      if (!doel) return;
      const slider = doel.closest('juno-slider');
      const index = [...doel.parentElement.children].indexOf(doel);
      if (slider?.aan && typeof slider.naar === 'function') slider.naar(index);
      else doel.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    };

    const werkBij = () => {
      const v = zoekVariant();
      volgTint();
      if (!v) return;

      if (idVeld) { idVeld.value = v.id; idVeld.disabled = !v.available; }
      if (knop) {
        knop.disabled = !v.available;
        const label = knop.querySelector('span');
        if (label && !v.available) label.textContent = knop.dataset.uitverkocht || 'Uitverkocht';
      }
      if (knopPrijs && v.price != null) knopPrijs.textContent = geld(v.price);
      prijsVelden.forEach((p) => {
        const nu = p.querySelector('.prijs__nu');
        const oud = p.querySelector('.prijs__vergelijk');
        if (nu) nu.textContent = geld(v.price);
        if (oud) oud.textContent = v.compare_at_price ? geld(v.compare_at_price) : '';
      });

      /* De prijs verandert hier zonder dat er iets in beeld springt: wie met een
         schermlezer een tint kiest hoort de tintnaam en verder niets. Daarom één
         melding met het nieuwe bedrag — en de uitverkocht-melding erachter als de
         knop zojuist op slot ging, want dat is minstens zo belangrijk. De tekst
         komt uit locales/ via een data-attribuut, niet uit dit bestand. */
      if (prijsMelding && v.price != null) {
        const uit = !v.available ? ` — ${prijsMelding.dataset.uitverkocht || ''}`.trimEnd() : '';
        prijsMelding.textContent = `${geld(v.price)}${uit}`;
      }

      /* De URL bijwerken zonder de pagina te herladen: deel je de link, dan komt
         de ander op dezelfde tint uit. Dat is precies waarom Iconic
         data-update-url op dit element zet. */
      if (blok.dataset.updateUrl === 'true' && v.id) {
        const url = new URL(window.location);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url);
      }
    };

    const geld = (centen) => {
      const bedrag = (centen / 100).toFixed(2).replace('.', ',');
      return `€ ${bedrag}`;
    };

    blok.addEventListener('change', werkBij);
  });

  /* Aantal: plus, min en de ondergrens uit data-min. Het veld hoort via het
     form-attribuut bij het productformulier, dus het aantal gaat mee zonder dat
     de knoppen iets hoeven te submitten. */
  document.querySelectorAll('quantity-input.js-quantity-input').forEach((blok) => {
    const veld = blok.querySelector('input');
    if (!veld) return;
    blok.querySelectorAll('button').forEach((knop) =>
      knop.addEventListener('click', (e) => {
        e.preventDefault();
        const min = parseInt(veld.dataset.min || '1', 10);
        const nu = parseInt(veld.value, 10) || min;
        veld.value = Math.max(min, knop.name === 'plus' ? nu + 1 : nu - 1);
        veld.dispatchEvent(new Event('change', { bubbles: true }));
      }));
  });

  /* De koopbalk op mobiel: verschijnt pas als de echte knop uit beeld is. Nooit
     erbovenop — daarom kijken we naar de positie van die knop en niet naar een
     scrolldrempel.

     Eerder stond hier een IntersectionObserver. Die is hier net verkeerd: hij
     vuurt alleen als de overlap VERANDERT. Kom je met een sprong op de pagina
     (een anker, een terugknop, een harde fling), dan is de knop van 'onder het
     scherm' naar 'boven het scherm' gegaan zonder ooit in beeld te zijn geweest
     — twee keer nul overlap, dus geen enkele melding, en de balk bleef weg.
     Meten bij het scrollen is hier eenvoudiger én altijd goed. */
  const koopbalk = document.querySelector('[data-koopbalk]');
  const echteKnop = document.querySelector('.js-buy-button [name="add"]');
  if (koopbalk && echteKnop) {
    koopbalk.hidden = false;
    koopbalk.setAttribute('aria-hidden', 'true');
    let gepland = false;
    const werkBalkBij = () => {
      gepland = false;
      const tonen = echteKnop.getBoundingClientRect().bottom < 0;
      koopbalk.classList.toggle('is-zichtbaar', tonen);
      /* Staat de balk over de tintkeuze heen, dan moet hij zeggen wélke tint hij
         toevoegt — anders koop je vanaf die balk blind. */
      const tintVeld = koopbalk.querySelector('[data-koopbalk-tint]');
      if (tintVeld) {
        const gekozenTint = document.querySelector('.variants--tintkaart input:checked');
        tintVeld.textContent = gekozenTint ? ` · ${gekozenTint.value}` : '';
      }
      // aria-hidden houdt hem uit de voorleesvolgorde zolang hij niet in beeld
      // is; de knop erin is een tweede exemplaar van dezelfde knop.
      koopbalk.setAttribute('aria-hidden', String(!tonen));
    };
    const plan = () => { if (!gepland) { gepland = true; requestAnimationFrame(werkBalkBij); } };
    window.addEventListener('scroll', plan, { passive: true });
    window.addEventListener('resize', plan);
    werkBalkBij();
  }

  /* De bundelkeuze: los of als set. Beide staan als radio buiten het formulier,
     zodat de knop één knop blijft; de gekozen radio bepaalt welke variant het
     formulier meestuurt. Zonder JavaScript blijft de eerste (losse) keuze staan
     en werkt de knop gewoon — je koopt dan het product waar je op staat. */
  document.querySelectorAll('[data-bundelkeuze]').forEach((keuze) => {
    const wortel = keuze.closest('.product') || document;
    const idVeld = wortel.querySelector('.product-variant-id');
    const knopPrijs = wortel.querySelector('.js-add-to-cart-price');
    const balkPrijs = document.querySelector('.koopbalk__prijs');
    const geld = (centen) => `€ ${(centen / 100).toFixed(2).replace('.', ',')}`;

    keuze.addEventListener('change', (e) => {
      const radio = e.target;
      if (radio.type !== 'radio') return;
      if (idVeld) idVeld.value = radio.value;
      const prijs = parseInt(radio.dataset.prijs, 10);
      if (!Number.isNaN(prijs)) {
        if (knopPrijs) knopPrijs.textContent = geld(prijs);
        if (balkPrijs) balkPrijs.textContent = geld(prijs);
      }
    });
  });

  /* De gallery vergroten. De lightbox stond er al (sections/modal-lightbox.liquid)
     en elke tegel draagt al een data-lightbox-index, maar er zat niets tussen: een
     productfoto van 1500 px die je niet kunt vergroten is bij verzorging precies de
     foto die je wilt zien. Alleen op een aanwijzer met een fijne punt; op een
     telefoon is de slider zelf al de vergroting. */
  /* Toegankelijkheid (04-09-2026, D2 punt 12). Hier stond `role="button"` plus
     `tabindex="0"` op de `<li>` van de galerij. Twee dingen gingen daar mis, en
     het tweede is het ergste:

     1. De tegel is een `<li>` in een `<ul>`. Een rol erop zetten VERVANGT de
        listitem-rol, dus de lijst verloor zijn tellinkje ("2 van 9") — precies
        het houvast dat je in een galerij nodig hebt.
     2. Een `role="button"` zónder naam is een knop die "knop" heet. De <img>
        eronder draagt de alt, maar die telt niet als naam van de <li>. Een
        verkeerde rol is schadelijker dan geen rol: hiervoor hoorde je "beeld,
        MARR Grow Oil", daarna hoorde je "knop" en verder niets.

     Nu een échte `<button>` óm het beeld heen, met de alt van dat beeld als
     naam. De browser levert dan zelf de rol, de tabvolgorde, Enter én spatie —
     de handgeschreven keydown kan weg. De `<li>` blijft een `<li>`.

     De knop wordt alleen gebouwd op een aanwijzer met een fijne punt; op een
     telefoon is de slider zelf de vergroting en zou er een tabstop per beeld bij
     komen zonder dat er iets te openen valt. */
  const lightbox = document.querySelector('#ProductLightbox');
  const doek = lightbox?.querySelector('.js-lightbox-content');
  if (lightbox && doek && window.matchMedia('(pointer: fine)').matches) {
    document.querySelectorAll('.slider--media-gallery .slider__item[data-lightbox]').forEach((tegel) => {
      const beeld = tegel.querySelector('img');
      if (!beeld) return;
      if (tegel.querySelector('.js-vergroot')) return;
      tegel.classList.add('is-vergrootbaar');

      const knop = document.createElement('button');
      knop.type = 'button';
      knop.className = 'vergroot-knop js-vergroot';
      /* De naam van de knop is de alt van het beeld. Is die leeg — bij een
         decoratief beeld hoort dat zo — dan valt hij terug op het vertaalde
         label dat de sectie meegeeft (`product.beeld`, "Productbeeld"), zodat er
         nooit een naamloze knop overblijft en er ook geen Nederlands in dit
         bestand hoeft te staan. */
      const val = tegel.closest('[data-beeld-label]')?.dataset.beeldLabel;
      knop.setAttribute('aria-label', beeld.alt || val || '');
      /* De knop komt om de <picture> heen, niet om de <img>: die <img> zit ín de
         picture, dus hem daar uit halen zou de <source>-regels loskoppelen. Staat
         er geen picture omheen, dan is het beeld zelf de inhoud. */
      const inhoud = beeld.closest('picture') || beeld;
      inhoud.parentNode.insertBefore(knop, inhoud);
      knop.appendChild(inhoud);

      knop.addEventListener('click', () => {
        doek.innerHTML = '';
        const groot = new Image();
        groot.src = beeld.currentSrc || beeld.src;
        groot.alt = beeld.alt;
        groot.className = 'o-img';
        doek.appendChild(groot);
        lightbox.show?.(knop);
      });
    });
  }

  /* De tooltip bij een swatch: verschijnt op hover én op focus, want een tint
     kiezen met het toetsenbord moet net zo goed werken. */
  document.querySelectorAll('.js-tooltip').forEach((label) => {
    const tip = document.getElementById(label.dataset.tooltip);
    if (!tip) return;
    const toon = (aan) => {
      tip.hidden = !aan;
      if (!aan) return;
      const r = label.getBoundingClientRect();
      tip.style.top = `${window.scrollY + r.bottom + 8}px`;
      tip.style.left = `${window.scrollX + r.left + r.width / 2 - tip.offsetWidth / 2}px`;
    };
    label.addEventListener('pointerenter', () => toon(true));
    label.addEventListener('pointerleave', () => toon(false));
    label.addEventListener('focusin', () => toon(true));
    label.addEventListener('focusout', () => toon(false));
  });
})();
